{
  "form": {
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete"
  },
  "stepper": {
    "back": "Back",
    "next": "Next",
    "finish": "Finish"
  },
  "notices": {
    "your_session_expired": "Your session has expired. Please login again."
  },
  "table": {
    "actions": "Actions"
  },
  "server_validations": {
    "empty_body": "Something is wrong",
    "invalid_credentials": "Invalid credentials",
    "not_found": "Not found",
    "duplicate_email": "Duplicate email",
    "null_not_allowed": "This field is required",
    "missing_value": "Missing value",
    "invalid_language": "Invalid language",
    "invalid_number_string": "Enter only digits"
  },
  "label": {
    "organization": "Organization",
    "organizations": "Organizations",
    "department": "Department",
    "departments": "Departments",
    "ok": "Ok",
    "cancel": "Cancel",
    "search": "Search",
    "accept": "Accept",
    "decline": "Decline",
    "cancel_invite": "Cancel invite",
    "cancel_registration_invite": "Cancel registration invite",
    "select_dep": "Select department {{id}}",
    "select_proj": "Select project {{id}}",
    "select_clust": "Select cluster {{id}}",
    "select_user": "Select user {{id}}",
    "manage_dep": "Manage department {{id}}",
    "manage_proj": "Manage project {{id}}",
    "manage_clust": "Manage cluster {{id}}",
    "remove_user_from_org": "Remove user {{id}} from organization",
    "remove_user_from_dep": "Remove user {{id}} from department",
    "remove_user_from_proj": "Remove user {{id}} from project",
    "leave_org": "Leave organization",
    "notif_item": "Notification item",
    "default": "default"
  },
  "steps": {
    "numberOfTotal": "{{number}} of {{total}}"
  },
  "home": {
    "user_greeting": "Hi, {{userName}}",
    "services_status": "Services Status",
    "your_organisations": "Your organisations",
    "your_favorite_services": "My favorites",
    "no_favorite_services": "You haven’t added any favorites yet!",
    "no_organizations": "You have no organizations",
    "no_organizations_annotation": "Only superusers may create organizations",
    "no_chart_data": "No data available yet. Once you start creating services, their states will appear here!"
  },
  "languages": {
    "en": "English",
    "de": "German",
    "es": "Spanish"
  },
  "dates": {
    "from_now": "{{date|$from_now}}",
    "long_date": "{{date|$MMMM D, y}}"
  },
  "errors": {
    "unexpected_error": "Unexpected error. Try again later.",
    "internal_error": "Internal error. Please contact your superuser."
  },
  "dataset_import_errors": {
    "dataset_import_already_processed": "This dataset import has either already been processed or is currently being imported.",
    "dataset_already_queued": "This dataset has already been queued for importing.",
    "insufficient_space": "Since the last retrieval the remaining database space has changed and is no longer sufficient. Please try again.",
    "dataset_import_not_readonly": "This dataset is not readonly.",
    "dataset_import_not_present": "This dataset does not exist in the database.",
    "dataset_import_not_abortable": "This dataset import can not be aborted."
  },
  "delete_entity_error": {
    "has_clusters": "Sorry, you can't delete the {{entity_name}}, because it has running clusters at the moment"
  },
  "delete_account_errors": {
    "target_user_is_owner": "You are the owner of the organization. Please, remove it and try again.",
    "has_clusters": "You still have clusters assigned. Please delete first and try again."
  },
  "leave_organization_errors": {
    "no_owners_left": "You can't leave {{organization_name}} as you are the only owner of this organization.",
    "has_clusters": "You can't leave {{organization_name}}, because it has running clusters at the moment."
  },
  "delete_department_errors": {
    "has_clusters": "Department {{department_name}} cannot be deleted, as it still includes clusters."
  },
  "update_cluster_errors": {
    "insufficient_resources": "The server does not have enough resources to extend this cluster. Please contact your superuser to extend the allocation, or try it with a smaller compute plan.",
    "is_creating": "The cluster can not be edited during creation"
  },
  "node_restart_errors": {
    "node_already_restarting": "Node {{instanceId}} ({{instanceRole}}) is already being restarted.",
    "node_restart_timeout": "Could not restart node {{instanceId}} ({{instanceRole}}) - please try again later."
  },
  "confirmation": {
    "generate_new_password": "Are you sure that you want to generate a new password?",
    "delete_organization": "Are you sure that you want to delete {{name}} organization?",
    "delete_department": "Are you sure that you want to delete {{name}} department?",
    "delete_department_plural": "Are you sure that you want to delete {{name}} departments?",
    "delete_project": "Are you sure that you want to delete {{name}} project?",
    "delete_project_plural": "Are you sure that you want to delete {{name}} projects?",
    "delete_cluster": "Are you sure that you want to delete {{name}} cluster?",
    "delete_user_from_organization": "Are you sure that you want to remove {{name}} user from the organization?",
    "delete_user_from_department": "Are you sure that you want to remove {{name}} user from the department?",
    "delete_user_from_project": "Are you sure that you want to remove {{name}} user from the project?",
    "delete_account": "Are you sure that you want to delete your account?",
    "leave_dirty_form": "Your changes are not saved. Are you sure?",
    "yes": "Yes",
    "no": "No"
  },
  "warnings": {
    "exceeded_file_size_with_max": "Your file is too big. Max size is {{maxSize}}"
  },
  "link_expired": {
    "link_expired": "Link expired",
    "email_successful": "Email verification successful",
    "button": "Yay, let's go!"
  },
  "document_title": {
    "app_name": "Scalefield",
    "title": "$t(document_title.app_name) - {{page_title}}"
  },
  "page_titles": {
    "about": "About",
    "profile": "Profile",
    "help": "Help",
    "forgot_password": "Forgot password",
    "login": "Login",
    "sing_up": "Sing up",
    "home": "Home",
    "support": "Support",
    "organizations": "Organizations",
    "department_manage": "{{department}} manage",
    "project_manage": "{{project}} manage",
    "organization_manage": "{{organization}} manage",
    "page_not_found": "404 Page not found",
    "help_search": "Help search",
    "help_search_results": "Search results for \"{{query}}\"",
    "system_configuration": "System Configuration",
    "email_configuration": "Email configuration",
    "imprint_configuration": "Imprint configuration",
    "imprint": "Imprint",
    "email_test": "Email Test",
    "orphans": "Orphans",
    "whitelisted_orphans": "Orphan whitelist",
    "non_orphans": "Customer clusters"
  },
  "no_item_text": {
    "no_organizations": "You have no organizations yet.",
    "data_not_found": "Data not found"
  },
  "format_currency": {
    "currency": "{{value|currency}}",
    "currencyShort": "{{value|currencyShort}}"
  },
  "modal": {
    "submit": "Submit",
    "cancel": "Cancel"
  },
  "reportable_error": {
    "title": "Oops, something went wrong there.",
    "codes": {
      "unprocessable_entity": "It looks like there was an error with the structure of the HTTP request.",
      "duplicate_identifier": "That identifier is already being used.",
      "_fallback": "Error code: "
    },
    "click_to_show_more": "Click here for more details...",
    "call_to_action": "If you encounter this problem again, we would appreciate it if you could report it to us.",
    "dismiss": "Dismiss"
  }
}
